import { Injectable } from "@angular/core";
import { HttpService } from "../../../core/shared/http.service";
import { DataEndChannel } from "../interfaces/data-end-channel.interface";
import { Observable } from "rxjs";
import { DataEndChannelConnection } from "../interfaces/data-end-channel-connection.interface";
import { Fallbacksettings } from "../../project-settings/shared/fallbacksettings";
import { ProjectImageBrightness } from "../interfaces/project-image-brightness.interface";
import { SetDoControl } from "../interfaces/set-do-control";
import { SetMqControl } from "../interfaces/set-mq-control";
import { SetAqControl } from "../interfaces/set-aq-control";
import { SetBarrierControl } from "../interfaces/set-barrier-control";
import { WeatherConfig } from "../interfaces/weather-config.interface";

@Injectable({
    providedIn: 'root'
})
export class DataEndChannelService {
    constructor(private readonly httpService: HttpService) { }

    public createNewDataEndChannel(dataEndChannel: DataEndChannel): Observable<DataEndChannel> {
        return this.httpService.post<DataEndChannel>('DataEndChannel', dataEndChannel);
    }

    public setDisplayType(channelId: number, displayId: number | string): Observable<any> {
        return this.httpService.post<any>('DataEndChannel/' + channelId + '/Display/' + displayId, {});
    }

    public setRadarType(channelId: number, radarId: number | string): Observable<any> {
        return this.httpService.post<any>('DataEndChannel/' + channelId + '/Radar/' + radarId, {});
    }

    public editDataEndChannel(id: number, dataEndChannel: DataEndChannel): Observable<DataEndChannel> {
        return this.httpService.put('DataEndChannel/' + id, dataEndChannel);
    }

    /** Weather configuration of the channel; empty lists as long as nothing is configured. */
    public getWeatherConfig(id: number): Observable<WeatherConfig> {
        return this.httpService.get<WeatherConfig>('DataEndChannel/' + id + '/WeatherConfig');
    }

    /** Writes the weather configuration; the API merges it into the FG03 settings of the channel. */
    public updateWeatherConfig(id: number, weatherConfig: WeatherConfig): Observable<DataEndChannel> {
        return this.httpService.put<DataEndChannel>('DataEndChannel/' + id + '/UpdateWeatherConfig', weatherConfig);
    }

    public deleteDataEndChannel(id: number): Observable<any> {
        return this.httpService.delete<any>('DataEndChannel/' + id);
    }

    public getDataEndChannelConection(id: number): Observable<DataEndChannelConnection> {
        return this.httpService.get<DataEndChannelConnection>('DataEndChannel/' + id + '/connection');
    }

    public assignDataEndChannelToTimerSwitch(deId: number, timerId: number): Observable<any> {
        return this.httpService.get<any>('DataEndChannel/' + deId + '/timerswitch/' + timerId);
    }

    public deleteDataEndChannelTimerAssignment(deId: number): Observable<any> {
        return this.httpService.delete<any>('DataEndChannel/' + deId + '/timerswitch');
    }


    public setFallbackSettings(id: number, settings: Fallbacksettings): Observable<any> {
        return this.httpService.put('DataEndChannel/' + id + '/fallbacksettings', settings);
    }

    public setServerParameter(id: number, height: number, offset: number): Observable<any> {
        let parameter = {
            height: height,
            offset: offset
        }
        return this.httpService.put('DataEndChannel/' + id + '/adecParameter', parameter);
    }

    public setBlinkerFallbackSettings(id: number, settings: Fallbacksettings): Observable<any> {
        return this.httpService.put('DataEndChannel/' + id + '/fallbacksettings', settings);
    }

    /* PUT
/DataEndChannel/{id}/brightness */
    public UpdateBrightnessLinkedMode(dataEndChannel: DataEndChannel): Observable<any> {
        return this.httpService.put('DataEndChannel/' + dataEndChannel.id + '/UpdateBrightnessLinkedMode', dataEndChannel);
    }

    public updateBrightnessParameters(id: number, brightnessModel: ProjectImageBrightness): Observable<any> {
        return this.httpService.put<any>(`DataEndChannel/${id}/UpdateBrightessParameter`, brightnessModel);
    }

    public updateDataEndChannelsLoggingByGuid(guid: string, loggingActive: boolean): Observable<any> {
        return this.httpService.put('DataEndChannel/UpdateDataEndChannelsLoggingByGuid/' + guid, loggingActive);

    }

    public updateDataEndChannelsSurveillanceByGuid(guid: string, surveillanceActive: boolean): Observable<any> {
        return this.httpService.put('DataEndChannel/UpdateDataEndChannelsSurveillanceByGuid/' + guid, surveillanceActive);
    }

    /* manual controls */

    public setDoManualControl(id: number, digitalOutputConfig: SetDoControl): Observable<any> {
        return this.httpService.post('DataEndChannel/' + id + '/setdomanualcontrol', digitalOutputConfig);
    }

    public setMqManualControl(id: number, mqConfig: SetMqControl): Observable<any> {
        return this.httpService.post('DataEndChannel/' + id + '/setmqmanualcontrol', mqConfig);
    }

    public setAqManualControl(id: number, aqConfig: SetAqControl): Observable<any> {
        return this.httpService.post('DataEndChannel/' + id + '/setaqmanualcontrol', aqConfig);
    }

    public setDiManualControl(id: number, diConfig: SetDoControl): Observable<any> {
        return this.httpService.post('DataEndChannel/' + id + '/setdimanualcontrol', diConfig);
    }
    public setBarrierManualControl(id: number, barrierConfig: SetBarrierControl): Observable<any> {
        return this.httpService.post('DataEndChannel/' + id + '/setbarriermanualcontrol', barrierConfig);
    }
}
